














import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Phase, PhaseKeys } from '@/models/phase';
import { ProcessModule } from '@/store/modules/process';

export interface MenuItem {
  heading: string;
  id: string;
  show: boolean;
}

@Component({})
export default class ProcessMenu extends Vue {
  @Prop(String) phase!: Phase;
  @Prop(Boolean) canEdit!: boolean;
  @Prop(Boolean) isReporting!: boolean;

  private itemInView: MenuItem | null = null;
  private listener!: () => void;

  mounted() {
    this.listener = this.update.bind(this);
    window.addEventListener('scroll', this.listener);
    window.addEventListener('resize', this.listener);
    setTimeout(() => this.update());
  }

  destroyed(): void {
    window.removeEventListener('resize', this.listener);
    window.removeEventListener('scroll', this.listener);
  }

  get items() {
    return [
      { heading: 'Grundlæggende oplysninger', id: 'general-information', show: true },
      { heading: 'Problemstillinger', id: 'challenges', show: true },
      { heading: 'Tid og proces', id: 'time-and-process', show: true },
      { heading: 'Faglig vurdering', id: 'assessment', show: ProcessModule.minPhase(PhaseKeys.PREANALYSIS) },
      {
        heading: 'Udvikling og implementering',
        id: 'implementation',
        show: ProcessModule.minPhase(PhaseKeys.DEVELOPMENT)
      },
      { heading: 'Drift', id: 'operation', show: ProcessModule.minPhase(PhaseKeys.OPERATION) },
      { heading: 'Bilag og links', id: 'attachments', show: ProcessModule.minPhase(PhaseKeys.PREANALYSIS) },
      { heading: 'Interne noter', id: 'internal-notes', show: this.canEdit }
    ];
  }

  private scrollTo(item: MenuItem) {
    const element = document.getElementById(item.id);

    if (element) {
      element.scrollIntoView(true);

      // Delay setting itemInView to after the scroll event fired
      requestAnimationFrame(() => (this.itemInView = item));
    }
  }

  private update() {
    if (!this.items) {
      return;
    }
    this.itemInView = this.getElementInView(this.items);
  }

  private getElementInView(items: MenuItem[]): MenuItem {
    const distanceFromTop = 90;

    const breakpoint = window.pageYOffset + distanceFromTop;

    for (let i = items.length - 1; i >= 0; i--) {
      const element = document.getElementById(items[i].id);

      if (element && element.offsetTop < breakpoint) {
        return items[i];
      }
    }

    return items[0];
  }
}
